import Drawer from '@material-ui/core/Drawer';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { useState } from 'react';

import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import DrawerSettingIcon from '@material-ui/icons/Tune';
import Hearing from '@material-ui/icons/Hearing';

import { SvgIcon, Typography } from '@material-ui/core';

import MapIcon from '@material-ui/icons/Map';
import ReplayIcon from '@material-ui/icons/Replay';
import { ReactComponent as DoubleArrowRightIcon } from "./assets/icons/DoubleArrowRightIcon.svg";
import { ReactComponent as DoubleArrowLeftIcon } from "./assets/icons/DoubleArrowLeftIcon.svg";
import { ReactComponent as CloseIcon } from "./assets/icons/closeIcon.svg";
import { ReactComponent as AircraftSearchIcon } from "./assets/icons/aircraftSearchIcon.svg";
import RoomIcon from '@material-ui/icons/Room';

import useGlobalContext from './Context/useGlobalContext';
import PopperComponent from './commonComponents/PopperComponent';
import DefaultPopperBody from './components/DefaultPopperBody';
import FlightSearch from './components/FlightSearch';
import ReplaySidebar from './components/ReplaySideBar';
import MapStyle from './components/MapStyle';
import config from './config.json'
import AddressSearchBar from './components/AddressSearchBar';
import AddressPopper from './components/AddressPopper';

const drawerWidth = 103;



interface SidebarProps {
  onClickApply: (time: any) => void
}

const removeFromSideBar: string[] = config.removeFromSideBar

const renameSideBar: {
  key: string;
  value: string;
}[] = config.renameSideBar

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      position: "absolute",
      top: "70px",
      left: "20px",
      zIndex: 10

    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerExpand: {
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      height: '100%',
      overflowX: 'hidden',
      borderRight: '0px',
      top: '55px'
    },
    drawerCollapse: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: 'hidden',
      width: theme.spacing(7.39) + 1,
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(10) + 1,
      },
      height: '100%',
      borderRight: '0px',
      top: '55px'
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 5px',
      backgroundColor: theme.palette.primary.main,
      height: '25px',
      zIndex: 1,
      // necessary for content to be below app bar
      // ...theme.mixins.toolbar,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    iconButton: {
      backgroundColor: 'transparent !important',
      '& svg': {
        width: '14px',
        height: '14px',
        color: '#F8F7FA',
      },
    },
    rotate180: {
      transform: `rotate(180deg)`,
    },
    drawerIcon: {
      backgroundColor: theme.palette.background.paper,
      width: '38px',
      height: '38px'
    },
    listContainer: {
      display: 'flex',
      height: '100%',
      flexDirection: 'column',
      padding: 0,
    },
    minWidth: {
      minWidth: 0,
      color: theme.palette.text.primary,
      marginBottom: '5px'
    },
    drawerButton: {
      width: '30px',
      height: '30px',
    },
    listItemContainer: { flexDirection: 'column', display: 'flex', height: '96px', justifyContent: 'center' },
    noDataFoundText: {
      fontWeight: theme.palette.type === 'dark' ? 500 : 600,
      fontSize: '13px',
      lineHeight: '15px',
      letterSpacing: '0.5px',
      color: `${theme.palette.text.primary} !important`,
      paddingBottom: '10px',
    },
    svgIconSize: {
      transform: 'scale(0.6)',
    },
  });
});

const renderSVGIcon = (Svg) => (
  <SvgIcon>
    <Svg />
  </SvgIcon>
);


const popperModifiers = {
  flip: {
    enabled: true,
  },
  hide: {
    enabled: false,
  },
  preventOverflow: {
    enabled: true,
    boundariesElement: 'viewport',
  },
  arrow: {
    enabled: false,
  },
};

let IconList = [
  {
    name: "SEARCH",
    id: "search",
    icon: <RoomIcon />,
    minWidth: "320px",
  },
  {
    name: "AIRCRAFT SEARCH",
    id: "aircraft_search",
    icon: renderSVGIcon(AircraftSearchIcon),
    minWidth: "320px",
  },
  {
    name: "BACKGROUND",
    id: "map_style",
    icon: <MapIcon />,
    minWidth: "160px",
  },
  {
    name: "REPLAY",
    id: "replay",
    icon: <ReplayIcon />,
    minWidth: "160px",
  },
  {
    name: config.noiseHeading,
    id: "complaint",
    icon: <Hearing />,
    minWidth: "160px",
  },
   
].filter((item) => !removeFromSideBar.some(i => i === item.id)).map((data) => {
  const renameData = renameSideBar.find((i) => i.key === data.id)
  if(renameData) {
    return {
      ...data,
      name: renameData.value
    }
  } else {
    return data
  }
})

export default function SideBar(props: SidebarProps) {
  const { onClickApply } = props;
 
  const classes = useStyles();
  const [isDrawerExpand, setDrawerExpand] = useState(true);
  const [isShowDrawer, setShowDrawer] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [anchorEl, setAnchorEl] = useState<any>('');
  const {setIsShowForm, setViewPort, setSearchViewPort, searchViewPort, viewPort, isAgreedTerms, setIsShowTermsAlert} = useGlobalContext()
  

   
  const collpaseDrawer = () => {
    setDrawerExpand((isDrawerExpand) => !isDrawerExpand);
  };

  const toggleDrawer = () => {
    setShowDrawer((isShowDrawer) => !isShowDrawer);
    setAnchorEl(null);
    setSelectedIndex(-1);
  };

   
 
  const handleListItemClick = ({ event, data, index }) => {
    setSelectedIndex(index);
 
    if(data.id === 'complaint'){
      setAnchorEl(null);
      if(isAgreedTerms) {
        setIsShowForm(true)
      } else {
        setIsShowTermsAlert(true)
      }
    }else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handlePopOverClose = () => {
    setAnchorEl(null);
  };
 
  const renderPopContent = ({ id }) => {
    try {
      switch (id) {
        
        case 'map_style': {
        
        return(
          <MapStyle />
        )
        }
        default:
          return <Typography className={classes.noDataFoundText}> No data found</Typography>;
      }
    } catch (error) {
      return <Typography className={classes.noDataFoundText}> No data found</Typography>;
    }
  };

  const openPopper = Boolean(anchorEl);

  const onChangeAddressValue = (latitude: number, longitude: number) => {
    setSearchViewPort({
      ...searchViewPort,
      latitude,
      longitude,
    });

    setViewPort({
      ...viewPort,
      zoom: 12,
      latitude,
      longitude,
    });
  };

  const onClearClick = () => {
    setSearchViewPort({
      latitude: 0,
      longitude: 0
    })
  }

  return (
    <div className={classes.root}>
      {!isShowDrawer ? (
        // <Tooltip title="Show Items" arrow>
        <IconButton onClick={toggleDrawer} className={clsx(classes.minWidth, classes.drawerIcon)}>
          <DrawerSettingIcon style={{width: '22px', height: '22px'}} />
        </IconButton>
      ) : (
        // </Tooltip>
        <Drawer
          variant="permanent"
          className={clsx(classes.drawer, {
            [classes.drawerExpand]: isDrawerExpand,
            [classes.drawerCollapse]: !isDrawerExpand,
          })}
          classes={{
            paper: clsx({
              [classes.drawerExpand]: isDrawerExpand,
              [classes.drawerCollapse]: !isDrawerExpand,
            }),
          }}
        >
          <div className={classes.toolbar}>
            {/* <Tooltip arrow title={isDrawerExpand ? 'Collapse' : 'Expand'}> */}
            <IconButton className={classes.iconButton}>
              {!isDrawerExpand ? (
                <DoubleArrowRightIcon className={classes.svgIconSize} />
              ) : (
                <DoubleArrowLeftIcon className={classes.svgIconSize} />
              )}
            </IconButton>
            {/* </Tooltip> */}
            {/* <Tooltip arrow title="Close"> */}
            <IconButton onClick={toggleDrawer} className={classes.iconButton}>
              <CloseIcon className={classes.svgIconSize} />
            </IconButton>
            {/* </Tooltip> */}
          </div>
          <Divider />
          <List className={classes.listContainer}>
              {IconList.map((data, index) => (
                <React.Fragment key={index}>
                  <ListItem
                    button
                    title=""
                    selected={selectedIndex === index}
                    className={classes.listItemContainer}
                    onClick={(event) => handleListItemClick({ event, data, index })}
                  >
                    <ListItemIcon className={classes.minWidth}>{data.icon}</ListItemIcon>
                    {isDrawerExpand ? <Typography className="text-center">{data.name}</Typography> : null}
                  </ListItem>
                  {selectedIndex === index && (
                    <PopperComponent
                      style={{ marginLeft: 0 }}
                      disablePortal={false}
                      modifiers={popperModifiers}
                      open={openPopper}
                      anchorEl={anchorEl}
                      placement={'right-start'}
                    >
                      {/* {data.value !== 'data_block' ? (
                        <DefaultPopperBody minWidth={data.minWidth} header={data.name} onClose={handlePopOverClose}>
                          {renderPopContent(data)}
                        </DefaultPopperBody>
                      ) : data.value !== 'rwy_safty' ? (
                        <DataBlockTabsPopper>{renderPopContent(data)}</DataBlockTabsPopper>
                      ) : (
                        <RunwayBody header={data.name} onClose={handlePopOverClose}>
                          {renderPopContent(data)}
                        </RunwayBody>
                      )}  */}
                      {  data.id === 'aircraft_search' ? (
                        <FlightSearch
                          minWidth={data.minWidth}
                          onClose={handlePopOverClose}
                        />
                      ) :
                      data.id === 'search' ? (
                        <AddressPopper minWidth={data.minWidth}  header={data.name} onClose={handlePopOverClose}>
                        <AddressSearchBar
                         onChangeAddressValue={onChangeAddressValue}
                         onClearClick={onClearClick}
                        />
                        </AddressPopper>
                      ) :  
                     data.id === 'replay' ? (
                        <DefaultPopperBody minWidth={data.minWidth}  header={data.name} onClose={handlePopOverClose}>
                          <ReplaySidebar onClickApply={onClickApply}/>
                          </DefaultPopperBody>
                      ) : (
                        <DefaultPopperBody minWidth={data.minWidth} header={data.name} onClose={handlePopOverClose}>
                          {renderPopContent(data)}
                        </DefaultPopperBody>
                      )}
                    </PopperComponent>
                  )}
                </React.Fragment>
              ))}
          </List>
          <Divider />
        </Drawer>
      )}
    </div>
  );
}
